<template>
    <div id="planning_provinsi" >

<section class="content">
<div class="container-fluid">

    <div class="row clearfix">

        <div class="bg-light-green" style="margin-top:-1% !important;">
            <!-- <br> -->
            <div class="row paddingku">
                <div class="col-md-3 searching">
                    <span class="h_page">Data Wilayah Provinsi</span> <br> <br>
                </div>
                <div class="col-md-6">

                </div>
                <div class="col-md-3 searching">
                    <div class="input-group">
                        <span class="input-group-btn">
                            <button :disabled="disabled" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                        </span>
                        <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                    </div> <br>
                </div>
            </div>
        </div>


        <div class="col-xs-12 card">
    <!-- ============================================================ MULAI ======================================================================== -->
            <br>
            <div class="table-responsive">
                <table class="table table-bordered" style="width: 100%">
                    <thead>
                    <tr class="bg-info">
                        <th style="width: 5%">No.</th>
                        <th style="width: 30%">Kode Urusan</th>
                        <th style="width: 30%">Nama Urusan</th>
                        <th style="width: 15%">Pilihan</th>
                    </tr>
                    </thead>
                    <tbody>
                        <!-- track-by="data.createdtime" -->
                        <tr class="h_isitable" v-for="(data, index) in list_provinsi" :key="data.provinsi_id">
                            <td>{{index+1}}</td>
                            <td>{{data.kode_provinsi}}</td>
                            <td>{{data.nama_provinsi}}</td>

                            <td class="text-center" >

                            <button @click="selectData(data.kode_provinsi, data.nama_provinsi, data.provinsi_id)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                <i class="material-icons" >create</i>
                            </button>
                                &nbsp;
                            <button @click="removeData(data.provinsi_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                <i class="material-icons" >clear</i>
                            </button>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>

            <hr>
                <div class="text-center">
                    <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                            <i class="material-icons">skip_previous</i>
                    </button>

                    <span style="font-size: 85%; color: #a5a5a5"><b>1 - 1</b></span>

                    <button type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                            <i class="material-icons">skip_next</i>
                    </button>
                </div>
            <hr>

            <!-- ============================================================ MODAL ======================================================================== -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-light-blue">
                                <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>
                                <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                            </div>
                        <form @submit.prevent="addData()">

                        <div class="modal-body">
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                <label for="kode">Kode Provinsi</label>
                                </div>
                                <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                    <input type="text" v-model="data.kode_provinsi" id="kode_provinsi" class="form-control" placeholder="Kode Provinsi" required>
                                    </div>
                                </div>
                                </div>
                            </div>
                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Provinsi</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="data.nama_provinsi" type="text" id="nama_provinsi" class="form-control" placeholder="Ex : Sulawesi Tenggara" required>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                            </div>
                        </form>

                        </div>
                    </div>
                </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-light-green">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>
                                <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                            </div>
                            <form @submit.prevent="editData()">

                            <div class="modal-body">

                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                <label for="kode">Kode Provinsi</label>
                                </div>
                                <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                    <input type="text" v-model="kode_provinsi" id="kode_urusan" class="form-control" placeholder="Kode Urusan">
                                    <input type="hidden" v-model="provinsi_id" id="urusan_pemerintahan_id" class="form-control" >
                                    </div>
                                </div>
                                </div>
                            </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Provinsi</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input type="text" v-model="nama_provinsi" id="nama_urusan" class="form-control" placeholder="Ex : Urusan Wajib Pelayanan Dasar">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="modal-footer">
                                <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                            </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


            <!-- ============================================================ MODAL ======================================================================== -->




    <!-- ============================================================ MULAI ======================================================================== -->
        </div>

    </div>

    </div>
    </section>



</div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/planning_provinsi/';
    export default {
        name: "planning_provinsi",
        data() {
            return {
                data:{
                    kode_provinsi: '',
                    nama_provinsi: '',
                    provinsi_id: '',
                },
                kode_provinsi: '',
                nama_provinsi: '',
                provinsi_id: '',
                list_provinsi: [],
                page_first : 1,
                page_last : 0,
                cari_value : '',
                disabled: false,
            };
        },

        mounted() {
            this.getData();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then(res => res.json()).then((data_urusan) => {
                  console.log(data_urusan);
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((datanya) => {
                  this.list_provinsi = datanya.data;
                  this.page_last = datanya.jml_data;
                  if (datanya.total > 0){
                      this.disabled = true;
                  } else {
                      this.disabled = false;
                  }
                  
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        kode_provinsi: this.kode_provinsi,
                        nama_provinsi: this.nama_provinsi,
                        provinsi_id: this.provinsi_id
                    })
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(kode_provinsi, nama_provinsi, id){
                this.provinsi_id = id;
                this.kode_provinsi = kode_provinsi;
                this.nama_provinsi = nama_provinsi;
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.data = {
                    id: '',
                    kode_urusan: '',
                    nama_urusan: '',
                    user: '',
                    createdtime: ''
                };
            },

            //PAGINASI
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
              if(this.page_first>1){
                this.page_first--
              }else{
                this.page_first = 1;
              }
              this.getData();
            },

            btn_next : function(){
              if(this.page_first >= this.page_last){
                this.page_first == this.page_last
              }else{
                this.page_first++;
              }
              this.getData();
            },

            cari_data : function(){
              this.getData();
            }
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
